import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useLocation } from "react-router-dom"

import { AppContext } from "../../../context/AppContext"
import { getCmsAssetsUrl } from "../../../helpers/general"

import styles from "./SectorsMenu.module.scss"

const assetsUrl = getCmsAssetsUrl()

const SectorsMenu = ({ from, scrollRef }) => {
  const location = useLocation()
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const { store, setStore } = useContext(AppContext)
  const [isCollapsed, setIsCollapsed] = useState(
    from !== "home" && !store.selectedSector
  )
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  const setSelectedSector = sector => {
    setStore(prevStore => {
      return { ...prevStore, ...{ selectedSector: sector.code } }
    })

    if (from === "home") {
      navigate(`/${i18n.language}/configure`, { state: { scrollToChargers: true } })
      return
    }
    scrollRef?.current?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    const segments = location.pathname.split("/").filter(Boolean);

    const isRootPath =
      segments.length === 0 ||
      (segments.length === 1 && segments[0].length === 2);

    if (isRootPath && store.selectedSector) {
      scrollRef?.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [location.pathname, store.selectedSector, scrollRef])


  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)
      // Force expanded state on mobile
      if (mobile && from !== "home") {
        setIsCollapsed(false)
      }
    }

    // Set initial state
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [from])

  useEffect(() => {
    if (from === "home") {
      setStore(prevStore => {
        return { ...prevStore, ...{ selectedSector: null } }
      })
    }

  }, [from, setStore])

  // Determine if menu should be collapsed (considering mobile state)
  const shouldBeCollapsed = isMobile ? false : isCollapsed

  return (
    <div className={styles.wrapper}>
      {from === "home" && (
        <>
          <div className={styles.container}>
            <p className={styles.bigText}>
              {t("Complete range of ev chargers")}
            </p>
            <p className={styles.bigText}>
              <strong>{t("Always easy Always powerful")}</strong>
            </p>
          </div>
          <div>
            <h3 className={styles.title}>
              {t("Electric charging solutions for every need")}
            </h3>
          </div>
        </>
      )}
      {from !== "home" && (
        <div className={styles.sectorsMenuTitleWrapper}>
          <div className={styles.sectorsMenuTitle}>
            {t("sectors menu homeConfigure")}
          </div>
          {!isMobile && (
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className={styles.toggleButton}
            >
              <img
                src={`${assetsUrl}/images/ingeteamev/icons/collapse-arrow.svg`}
                alt="Toggle"
                className={`${styles.collapseIcon} ${
                  isCollapsed ? "" : styles.rotated
                }`}
              />
            </button>
          )}
        </div>
      )}
      {!shouldBeCollapsed && (
        <div className={styles.sectorsMenuContainer}>
          {store.sectors.map(sector => (
            <div
              key={sector.code}
              className={`${styles.sectorContainer} ${
                store.selectedSector === sector.code ? styles.active : ""
              }`}
              role="button"
              onClick={() => {
                setSelectedSector(sector)
              }}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  setSelectedSector(sector)
                }
              }}
            >
              <div className={styles.sectorImageDiv}>
                <img
                  className={styles.sectorImage}
                  src={`${assetsUrl}/${store.initConfig.images}/configuration/solution/${sector.image}`}
                  alt={sector.image}
                />
              </div>
              <div className={styles.sectorDivider}></div>
              <div className={styles.sectorText}>{t(sector.text)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default SectorsMenu
